import React from 'react';
import { Button } from './Button';
import { ModalBase } from './ModalBase';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenContactModal: (subject?: string) => void;
}

const FeatureItem: React.FC<{ title: string, description: string, icon: React.ReactNode }> = ({ title, description, icon }) => (
    <div className="flex">
        <div className="flex-shrink-0">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-500 text-white">
                {icon}
            </div>
        </div>
        <div className="ml-4">
            <h4 className="text-lg leading-6 font-medium text-gray-900">{title}</h4>
            <p className="mt-2 text-base text-gray-600">{description}</p>
        </div>
    </div>
);

export const FranchiseModal: React.FC<ModalProps> = ({ isOpen, onClose, onOpenContactModal }) => {
    const handleContactClick = () => {
        onClose();
        onOpenContactModal('Información sobre Franquicias');
    };

  return (
    <ModalBase isOpen={isOpen} onClose={onClose} title="Únete a Nuestra Red: Sé una Franquicia">
        <div className="prose prose-lg max-w-none">
            <p className="lead text-xl text-gray-700">
                Abre tu propio negocio de defensa legal con el respaldo de una marca líder en Europa. Te ofrecemos un modelo de negocio probado, rentable y con un alto impacto social.
            </p>

            <h3 className="text-2xl font-bold text-gray-800 mt-10">¿Qué Ofrecemos?</h3>
            <div className="mt-6 grid gap-10">
                <FeatureItem 
                    title="Marca Reconocida" 
                    description="Benefíciate de la reputación y confianza de Multas.EU, Peritajes.EU y Juzgados.EU."
                    icon={<svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" /></svg>}
                />
                 <FeatureItem 
                    title="Tecnología de Vanguardia" 
                    description="Accede a nuestro software de gestión de expedientes, CRM y herramientas de marketing digital."
                    icon={<svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>}
                />
                 <FeatureItem 
                    title="Formación y Soporte" 
                    description="Te proporcionamos formación inicial y continua en áreas legales, comerciales y de gestión, además de soporte constante desde la central."
                    icon={<svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path d="M12 14l9-5-9-5-9 5 9 5z" /><path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-5.998 12.078 12.078 0 01.665-6.479L12 14z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-5.998 12.078 12.078 0 01.665-6.479L12 14z" /></svg>}
                />
            </div>

             <h3 className="text-2xl font-bold text-gray-800 mt-12">El Perfil Ideal</h3>
             <ul className="list-disc list-inside mt-4 space-y-2">
                <li>Profesionales con formación legal (abogados, graduados sociales, etc.).</li>
                <li>Emprendedores con vocación comercial y de gestión.</li>
                <li>Personas con un fuerte compromiso con la atención al cliente y la ética profesional.</li>
                <li>No se requiere experiencia previa en el sector, ¡nosotros te formamos!</li>
             </ul>
        </div>
      <div className="mt-12 bg-gray-50 p-6 rounded-lg text-center">
        <h4 className="text-xl font-bold text-gray-800">¿Listo para dar el siguiente paso?</h4>
        <p className="mt-2 text-gray-600">Contacta con nuestro equipo de expansión para recibir el dossier informativo sin compromiso.</p>
        <div className="mt-6">
            <Button onClick={handleContactClick} variant="primary" size="large">
                Solicitar Información
            </Button>
        </div>
      </div>
    </ModalBase>
  );
};
